// ─────────────────────────────────────────────────────────────────────────────
// INSTRUMENT: Cognitive Ability Battery (CAB)
// 6 timed tests: Numerical · Verbal · Abstract · Attention · Mechanical · Diagrammatic
// ─────────────────────────────────────────────────────────────────────────────
import { CAB_TESTS, CAB_NORMS, CAB_BANDS,
  scoreCAB, scoreCognitiveIndex } from "./scoring.js";
import { NUMERICAL_ITEMS, VERBAL_ITEMS, ABSTRACT_ITEMS,
  ATTENTION_ITEMS, MECHANICAL_ITEMS, DIAGRAMMATIC_ITEMS } from "./questionBank.js";

const ITEMS_MAP = {
  numerical:    NUMERICAL_ITEMS,
  verbal:       VERBAL_ITEMS,
  abstract:     ABSTRACT_ITEMS,
  attention:    ATTENTION_ITEMS,
  mechanical:   MECHANICAL_ITEMS,
  diagrammatic: DIAGRAMMATIC_ITEMS,
};

const CAB = {
  id:           "cab",
  name:         "Cognitive Ability Battery",
  shortName:    "CAB",
  icon:         "🧮",
  color:        "#1d4ed8",
  bg:           "#eff6ff",
  description:  "Six timed ability tests — Numerical, Verbal, Abstract, Attention to Detail, Mechanical and Diagrammatic Reasoning. Auto-scored against Global & Indian norms (n=7K+). Instant percentile bands and hiring recommendation per test.",
  desc:         "6 tests · 153 items · 90 min total · Auto-scored",
  publisher:    "AXIS360 Express",
  version:      "1.0",
  itemCount:    153,
  items:        153,
  totalQuestions: 153,
  timeLimit:    91,
  time:         "91 min",
  timeEstimate: "~90 min",
  format:       "timed_ability",
  isCognitive:  true,
  isExpress:    true,
  pricingTier:  "volume",
  creditCost:   20,
  tests:        Object.values(CAB_TESTS),
  scales:       Object.values(CAB_TESTS).map(t => ({
    id:    t.id,
    label: t.label,
    icon:  t.icon,
    color: "#1d4ed8",
    desc:  t.desc,
  })),
  predicts: [
    "Graduate and management trainee performance",
    "Analytical role success",
    "Training uptake speed",
    "Complex problem-solving ability",
  ],
  nineboxAxes: {
    x: { label: "Cognitive Performance",  scaleIds: ["numerical","verbal","abstract"] },
    y: { label: "Processing Capacity",    scaleIds: ["attention","mechanical","diagrammatic"] },
  },

  score(answers) {
    const testResults = {};
    Object.keys(ITEMS_MAP).forEach(testId => {
      const testAnswers = answers[testId];
      if (testAnswers) {
        testResults[testId] = scoreCAB(testId, testAnswers, ITEMS_MAP[testId]);
      }
    });
    const { cogIndex, band } = scoreCognitiveIndex(testResults);
    return {
      scales:       Object.fromEntries(Object.entries(testResults).map(([k,v]) => [k, v.percentile])),
      testResults,
      cogIndex,
      band,
      validityFlag: null,
      perfAvg:      cogIndex / 10,
      potAvg:       cogIndex / 10,
      perfBox:      cogIndex >= 70 ? 3 : cogIndex >= 40 ? 2 : 1,
      potBox:       cogIndex >= 70 ? 3 : cogIndex >= 40 ? 2 : 1,
    };
  },
};

export default CAB;
